import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getStaffAvatarUrl, staffAvatarSizes } from '@yandex-data-ui/common';
import { BASE_URL, HIGHLIGHT_PATTERN, SEARCH_PAGE_FOR_SCOPE } from '../constants';
import { getLang } from './i18n';
export function escapeHighlight(str) {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  return str.replace(HIGHLIGHT_PATTERN, '$1');
}
export function hasMatches(target) {
  return Boolean(target === null || target === void 0 ? void 0 : target.match(HIGHLIGHT_PATTERN));
}
export function filterMatches(target) {
  return target === null || target === void 0 ? void 0 : target.filter(function (elem) {
    return hasMatches(elem);
  });
}
export function formatDate(date, format) {
  if (!date || typeof date === 'string' && Number.isNaN(Date.parse(date))) {
    return '';
  }
  return new Date(date).toLocaleString(getLang(), format !== null && format !== void 0 ? format : {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}
export function getUserAvatarLink(login, size) {
  var scale = window.devicePixelRatio || 2;
  var scaledSize = size * scale;
  var existedSize = staffAvatarSizes.find(function (el) {
    return el >= scaledSize;
  }) || staffAvatarSizes[staffAvatarSizes.length - 1];
  return getStaffAvatarUrl(login, existedSize);
}
export function getSearchSiteUrl(_ref) {
  var _SEARCH_PAGE_FOR_SCOP;
  var text = _ref.text,
    scope = _ref.scope,
    filter = _ref.filter,
    _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? BASE_URL : _ref$baseUrl;
  var url = new URL("".concat((_SEARCH_PAGE_FOR_SCOP = SEARCH_PAGE_FOR_SCOPE[scope]) !== null && _SEARCH_PAGE_FOR_SCOP !== void 0 ? _SEARCH_PAGE_FOR_SCOP : '', "search"), baseUrl);
  if (text) {
    url.searchParams.set('text', text);
  }
  if (filter) {
    Object.entries(filter).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        name = _ref3[0],
        settings = _ref3[1];
      if (settings.active) {
        var _settings$value;
        (_settings$value = settings.value) === null || _settings$value === void 0 || _settings$value.forEach(function (val) {
          url.searchParams.append("facet.".concat(name), val);
        });
      }
    });
  }
  return url.toString();
}
export function debounce(func, wait) {
  var timeout;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(_this, args);
    }, wait);
    return timeout;
  };
}
export function throttle(func, limit) {
  var waiting = false;
  return function () {
    var _this2 = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (!waiting) {
      func.apply(this, args);
      waiting = true;
      setTimeout(function () {
        waiting = false;
        func.apply(_this2, args);
      }, limit);
    }
  };
}
export function getLocation() {
  var _process, _window$top;
  return typeof process !== 'undefined' && (_process = process) !== null && _process !== void 0 && (_process = _process.env) !== null && _process !== void 0 && _process.STORYBOOK_MODE ? (_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.location : window.location;
}
export function gotoLink(url) {
  var location = getLocation();
  if (location) {
    location.href = url;
  }
}
// #sourceMappingURL=helpers.js.map